import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';
import type { EpicWithThunk } from 'state/state.common';

import { applyTradeAllocationEpic } from './applyTradeAllocationEpic';
import { createTradeAllocationTabEpic } from './createTradeAllocationTabEpic';
import { fetchTradeAllocationCustodiansEpic } from './fetchTradeAllocationCustodiansEpic';
import { fetchTradeAllocationFormEpic, resetTradeAllocationFormEpic } from './fetchTradeAllocationFormEpic';
import { fetchTradeAllocationFormWhenWorkspaceAlreadyInitializedEpic } from './fetchTradeAllocationFormWhenWorkspaceAlreadyInitializedEpic';
import { fillTradeAllocationTabContentInPostTradeScreenEpic } from './tabContentEpic';

export function tradeAllocationFormEpic(): EpicWithThunk {
  return withAppCrashIfException(
    'tradeAllocationForm',
    combineEpics(
      createTradeAllocationTabEpic(),
      fillTradeAllocationTabContentInPostTradeScreenEpic(),
      fetchTradeAllocationFormEpic(),
      fetchTradeAllocationFormWhenWorkspaceAlreadyInitializedEpic(),
      fetchTradeAllocationCustodiansEpic(),
      applyTradeAllocationEpic(),
      resetTradeAllocationFormEpic(),
    ),
  );
}
